import { z } from 'zod';

/** First line of a battle log file (JSON Lines v1). See specs/save/battle-log-format.md and specs/battle/engine-rules.md */
export const battleLogMetaLineSchema = z.object({
  format: z.literal('battle-log'),
  version: z.number().int().min(1),
});

export type BattleLogMetaLine = z.infer<typeof battleLogMetaLineSchema>;
